import { render, staticRenderFns } from "./ListarConvenio.vue?vue&type=template&id=a23c0a00"
import script from "./ListarConvenio.vue?vue&type=script&lang=js"
export * from "./ListarConvenio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports